var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "observe-visibility",
          rawName: "v-observe-visibility",
          value: _vm.observeVisibilityOptions,
          expression: "observeVisibilityOptions",
        },
      ],
      staticClass: "home-events",
    },
    [
      _vm.exhibitions.length
        ? _c(
            "segment",
            {
              staticClass: "segment-exhibitions",
              attrs: { title: _vm.$t("navigation.sub.exhibitions") },
              scopedSlots: _vm._u(
                [
                  {
                    key: "display-options",
                    fn: function () {
                      return [
                        _vm.isIntersectionVisible
                          ? _c(
                              "div",
                              { staticClass: "display-option show-all" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: _vm.getLocalizedSearchRoute(
                                        "EventsSearch",
                                        { EventClass: "Exhibition" }
                                      ),
                                    },
                                  },
                                  [
                                    _c("icon-plus-circle-outline", {
                                      attrs: { title: "" },
                                    }),
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v(_vm._s(_vm.$t("common.showAll"))),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                1095470729
              ),
            },
            [
              _vm.isIntersectionVisible
                ? _c("event-brochure-stack", {
                    attrs: { items: _vm.exhibitions, count: 5 },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.events.length
        ? _c(
            "segment",
            {
              staticClass: "segment-events",
              attrs: { title: _vm.$t("navigation.sub.events") },
              scopedSlots: _vm._u(
                [
                  {
                    key: "display-options",
                    fn: function () {
                      return [
                        _vm.isIntersectionVisible
                          ? _c(
                              "div",
                              { staticClass: "display-option show-all" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: _vm.getLocalizedSearchRoute(
                                        "EventsSearch"
                                      ),
                                    },
                                  },
                                  [
                                    _c("icon-plus-circle-outline", {
                                      attrs: { title: "" },
                                    }),
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v(_vm._s(_vm.$t("common.showAll"))),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                237331088
              ),
            },
            [
              _vm.isIntersectionVisible
                ? _c("slick-slides", {
                    staticClass: "is-ancestor",
                    attrs: { options: _vm.slickOptions, items: _vm.events },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "slide-card",
                          fn: function (slotScope) {
                            return [
                              _c("event-card", {
                                attrs: {
                                  item: slotScope.item,
                                  "image-as-background": true,
                                  resolution: { x: "50vw" },
                                  social: false,
                                  "use-palette": true,
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3449745629
                    ),
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      !_vm.ready && !_vm.error ? _c("loading-spinner") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }